<style lang="less">
    .fill-panel {
        // padding: 14px;
        // padding-left: 20px;
        // padding-right: 20px;
        padding-top: 4px;
        position: relative;
    }
    .setting {
        margin-top: 16px;
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow: visible;
    }
    .mask {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0);
    }
</style>
<style lang="stylus">
    .fill-panel
        border-bottom-left-radius $right-view-radius
        border-bottom-right-radius $right-view-radius
        color $right-view-content-textcolor
        .ivu-radio-group-vertical
          .ivu-radio-wrapper
            height 16px;
            line-height 16px;
            &:not(:last-child)
                margin-bottom 12px;

        .mask
            border-bottom-left-radius $right-view-radius
            border-bottom-right-radius $right-view-radius
</style>

<template>
    <div class="fill-panel">
        <RadioGroup v-model="fillType" @on-change="changeFillType" vertical>
            <Radio label="No fill" :disabled="masked">
                <span>{{ $t("FillPanel.fillTypeRadio.noFill") }}</span>
            </Radio>
            <Radio label="Solid fill" :disabled="masked">
                <span>{{ $t("FillPanel.fillTypeRadio.solidFill") }}</span>
            </Radio>
            <Radio label="Gradient fill" :disabled="masked">
                <span>{{ $t("FillPanel.fillTypeRadio.gradientFill") }}</span>
            </Radio>
            <Radio label="Pattern fill" :disabled="masked">
                <span>{{ $t("FillPanel.fillTypeRadio.patternFill") }}</span>
            </Radio>
            <Radio label="Texture fill" :disabled="masked">
                <span>{{ $t("FillPanel.fillTypeRadio.textureFill") }}</span>
            </Radio>
        </RadioGroup>
        <div class="setting" v-if="fillType !== 'No fill' && !isMMShape">
            <component v-bind:is="currentSetComponent" :from="fmtType.fill" @changeSet="$emit('changeSet')"></component>
        </div>
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    declare var EDDocument: any;
    // import PatternFill from "./Pattern.vue";
    // import GradientFill from "./Gradient.vue";
    // import SolidFill from "./SolidFill.vue";
    // import TextureFill from "./Texture.vue";
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            SolidFill: () => import("./SolidFill.vue"),
            GradientFill: () => import("./Gradient.vue"),
            PatternFill: () => import("./Pattern.vue"),
            TextureFill: () => import("./Texture.vue"),
        },
    })
    export default class FillPanel extends Vue {
        color: string = "#000000";

        changeFillType(v) {
            let dochange = () => {
                this.$track("rightPanel", "fill type", v);
                let view = window["_view"];
                if (v !== this.fillType) {
                    window["_view"]._tool.endEdit();
                    if (v === "No fill") {
                        view.setFmt({}, eFmtSetFlag.ColorNone | this.fmtType.fill);
                    } else if (v === "Solid fill") {
                        view.setFmt({}, eFmtSetFlag.ColorSolid | this.fmtType.fill);
                    } else if (v === "Gradient fill") {
                        view.setFmt({}, eFmtSetFlag.ColorGradient | this.fmtType.fill);
                    } else if (v === "Pattern fill") {
                        view.setFmt({}, eFmtSetFlag.ColorPattern | this.fmtType.fill);
                    } else if (v === "Texture fill") {
                        view.setFmt({}, eFmtSetFlag.ColorTexture | this.fmtType.fill);
                    }
                    window["_view"]._tool.endEdit();
                    this.changeSet();
                }
            };
            if (v === "Texture fill") {
                console.log("select texture filllllllll");
                if (!this.textureLoadedStatus) {
                    this.textureLoadedStatus = 1;
                    this.$store.dispatch("loadConfig", ["texture.tar"]).then((e) => {
                        EDDocument.loadTextureData(this.$store.state.ui.textureImgUrl).then(() => {
                            this.textureLoadedStatus = 2;
                            dochange();
                        });
                    });
                } else if (this.textureLoadedStatus == 2) {
                    dochange();
                }
            } else {
                dochange();
            }
        }
        changeSet() {
            this.$emit("changeSet");
        }
        get isMMShape() {
            return this.$store.state.shape.isMMShape;
        }
        get textureLoadedStatus() {
            return this.$store.state.ui.textureLoadedStatus;
        }
        set textureLoadedStatus(v) {
            this.$store.commit("setStatus", {
                type: "textureLoadedStatus",
                data: v,
            });
        }
        get currentSetComponent() {
            if (this.fillType === "Solid fill") {
                return "SolidFill";
            } else if (this.fillType === "Gradient fill") {
                return "GradientFill";
            } else if (this.fillType === "Pattern fill") {
                return "PatternFill";
            } else if (this.fillType === "Texture fill") {
                return "TextureFill";
            }
        }
        get masked() {
            return !this.$store.state.shape.canFill || this.isMMShape || this.isLine;
        }
        get isLine() {
            return this.$store.state.shape.isLine;
        }
        get fillType() {
            let type: number = this.type;
            if (type === null) {
                return "No fill";
            }
            if (type === 0) {
                return "No fill";
            } else if (type === 1) {
                return "Solid fill";
            } else if (type > 1 && type < 5) {
                return "Gradient fill";
            } else if (type === 6) {
                return "Pattern fill";
            } else if (type === 7) {
                return "Texture fill";
            }
        }
        set fillType(v: any) {}
        get type() {
            //是否disabled
            return this.$store.state.shape.fillFmt.type;
        }
        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        // @Watch('type')
        // onTypeChanged(val: any) {
        //     if(val === null ){
        //         this.masked = true;
        //     }else{
        //         this.masked = false;
        //     }
        // }
        activated() {
            this.$bus.$emit("setRightViewTitle", "");
        }
        mounted() {
            // if(this.type === null){
            //     this.masked = true;
            // }
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "无填充",
        "solidFill": "单色填充",
        "gradientFill": "渐变填充",
        "patternFill": "图案填充",
        "textureFill": "图片填充"
      }
    }
  },
  "en": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "No Fill",
        "solidFill": "Solid Fill",
        "gradientFill": "Gradient Fill",
        "patternFill": "Pattern Fill",
        "textureFill": "Picture Fill"
      }
    }
  },
  "fr": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "Aucun remplissage",
        "solidFill": "Remplissage solide",
        "gradientFill": "Remplissage en dégradé",
        "patternFill": "Remplissage en motif",
        "textureFill": "Remplissage d'image"
      }
    }
  },
  "de": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "Keine Füllung",
        "solidFill": "Einfarbige Füllung",
        "gradientFill": "Farbverlauf",
        "patternFill": "Musterfüllbereich",
        "textureFill": "Bilderfüllung"
      }
    }
  },
  "jp": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "塗りつぶしなし",
        "solidFill": "単一色の塗りつぶし",
        "gradientFill": "グラデーション塗りつぶし",
        "patternFill": "パターンの塗りつぶし",
        "textureFill": "画像の塗りつぶし"
      }
    }
  },
  "es": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "Sin relleno",
        "solidFill": "Relleno sólido",
        "gradientFill": "Relleno de gradiente",
        "patternFill": "Relleno de patrones",
        "textureFill": "Relleno de imágenes"
      }
    }
  },
  "pt": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "Sem Preenchimento",
        "solidFill": "Preenchimento Sólido",
        "gradientFill": "Preenchimento em Gradiente",
        "patternFill": "Preenchimento com Padrão",
        "textureFill": "Preenchimento com Imagem"
      }
    }
  },
  "it": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "Nessun Riempimento",
        "solidFill": "Riempimento Solido",
        "gradientFill": "Riempimento Gradiente",
        "patternFill": "Riempimento con Motivo",
        "textureFill": "Riempimento con Immagine"
      }
    }
  },
  "tw": {
    "FillPanel": {
      "fillTypeRadio": {
        "noFill": "無填充",
        "solidFill": "單色填充",
        "gradientFill": "漸變填充",
        "patternFill": "圖案填充",
        "textureFill": "圖片填充"
      }
    }
  }
}
</i18n>
